import { iUser } from "@sdk/services/models";

export const getUserName = (user: iUser) =>
  [user?.data.firstName, user?.data.lastName].filter((part) => part).join(" ");
